import {
  Instance,
  Store,
  putInstanceObject,
  Contact,
  putUpdateContactObject,
  postContactObject,
  postInstaceActivateContacsObject,
  CreateHeadersData,
  CreateHeaderResponse,
  ChatBotFileData,
  ChatbotPostPutCalendarObject,
  ChatbotPostPutTriggerObject,
  ChatbotDelTriggerObject,
  ChatbotGetTriggersObject,
  ChatbotPutInactivateCalendarObject,
  Group,
} from "../types/whatsapp";
import { FormikInstance } from "../components/ConfigInstanceDialog";
import { ENV } from "../utils/constants";
import api from "./api";

// type ResultStatusInstance = Pick<StatusInstance, "connected" | "qr">;

export const getInstances = async (): Promise<Instance[]> => {
  const params = {};
  const response = await api.get(`/whatsapp-v2-${ENV}/instances/client/list`, {
    params,
  });
  return response.data?.content;
};

export const postInstances = async (instance: FormikInstance): Promise<any> => {
  const response = await api.post(
    `/whatsapp-v2-${ENV}/instances/client/create`,
    {
      name: instance.name,
      store: instance.id_loja,
      phone: instance.own_number,
    }
  );
  return response;
};
export const putInstance = async (
  instanceUpdate: putInstanceObject
): Promise<any> => {
  const response = await api.put(
    `/whatsapp-v2-${ENV}/instances/client/update`,
    instanceUpdate
  );
  return response;
};

export const getStatusInstance = async (id: number): Promise<any> => {
  const response = await api.post(`/whatsapp-v2-${ENV}/zapi/qrcode/image`, {
    client: id,
  });

  return response.data.content;
};

export const instanceActivateContacts = async (
  contact: postInstaceActivateContacsObject
): Promise<any> => {
  const response = await api.post(
    `/whatsapp-v2-${ENV}/contacts/active`,
    contact
  );

  return response.data.content;
};

export const getStores = async (): Promise<Store[]> => {
  const params = {};
  const response = await api.get(`/config-p1-${ENV}/${ENV}/crm/getLojas`, {
    params,
  });

  return response.data;
};

export const getContacts = async (
  cellphone?: string | null,
  id?: number | null,
  name: string = "",
  status?: number | null
): Promise<Contact[]> => {
  const response = await api.get(`/whatsapp-v2-${ENV}/contacts/list`, {
    params: {
      cellphone,
      id,
      name,
      status,
    },
  });
  return response.data.content;
};

export const postContact = async (contact: postContactObject): Promise<any> => {
  const response = await api.post(
    `/whatsapp-v2-${ENV}/contacts/create`,
    contact
  );

  return response.data.content;
};

export const putUpdateContact = async (
  contact: putUpdateContactObject
): Promise<any> => {
  const response = await api.put(
    `/whatsapp-v2-${ENV}/contacts/update`,
    contact,
    {}
  );

  return response.data.content;
};

export const deleteInstance = async (id: number) => {
  const response = await api.delete(
    `/whatsapp-v2-${ENV}/instances/client/delete`,
    { data: { id } }
  );
  return response.data.content;
};

export const createHeaders = async (
  data: CreateHeadersData
): Promise<CreateHeaderResponse> => {
  const response = await api.post(
    `/importacao-p2-${ENV}/${ENV}/crm/postFileHeaderWhatsapp`,
    data
  );
  return response.data.data;
};

export const createImportFile = async (
  data: ChatBotFileData
): Promise<string> => {
  const requestObjectData = {
    fileLength: data.fileRows,
    fileLink: data.fileUrl,
    fileName: data.fileName,
    headerLink: data.fileHeaderUrl,
    keyImport: data.identificator?.column,
    ruleImport: data.rule,
    typeImport: data.typeImport,
  };
  const response = await api.post(
    `/importacao-p2-${ENV}/${ENV}/crm/postFileImportWhatsapp`,
    requestObjectData
  );
  return response.data;
};

export const zapiDisconnect = async (idInstancia: number) => {
  const response = await api.post(`/whatsapp-v2-${ENV}/zapi/disconnect`, {
    client: idInstancia,
  });
  return response;
};

export const desactiveContact = async (numero: string, idInstancia: number) => {
  await api.delete(`/whatsapp-v2-${ENV}/contacts/delete`, {
    data: {
      cellphone: numero,
      instance_id: idInstancia,
    },
  });
};

export const getCalendarChatbot = async (instanceId: number) => {
  const response = await api.get(
    `/chatbot-v2-${ENV}/calendars/list?instance_id=${instanceId}`
  );
  return response.data.content;
};

export const postCalendarChatbot = async (
  param: ChatbotPostPutCalendarObject
) => {
  const response = await api.post(`/chatbot-v2-${ENV}/calendars/create`, param);
  return response.data.content;
};

export const putCalendarChatbot = async (
  param: ChatbotPostPutCalendarObject | ChatbotPutInactivateCalendarObject
) => {
  const response = await api.put(`/chatbot-v2-${ENV}/calendars/update`, param);
  return response.data.content;
};

export const getTriggersChatbot = async (param: ChatbotGetTriggersObject) => {
  const response = await api.get(
    `/chatbot-v2-${ENV}/trigger/list?calendar_id=${param.calendar_id}`
  );
  return response.data.content;
};

export const postTriggerChatbot = async (
  param: ChatbotPostPutTriggerObject
) => {
  const response = await api.post(`/chatbot-v2-${ENV}/trigger/create`, param);
  return response.data.content;
};

export const putTriggerChatbot = async (param: ChatbotPostPutTriggerObject) => {
  const response = await api.put(`/chatbot-v2-${ENV}/trigger/update`, param);
  return response.data.content;
};

export const deleteTriggerChatbot = async (param: ChatbotDelTriggerObject) => {
  const response = await api.delete(
    `/chatbot-v2-${ENV}/trigger/delete/${param.trigger_id}`
  );
  return response.data.content;
};

export const getGroups = async (
  instance_id: number,
  status?: number,
  name?: string
): Promise<Group[]> => {
  const response = await api.get(`/whatsapp-v2-${ENV}/groups/list`, {
    params: {
      client: instance_id,
      status: typeof status !== "number" ? 2 : status,
      name,
    },
  });
  return response.data.content;
};

export const updateGroups = async (group: any): Promise<any> => {
  const response = await api.put(`/whatsapp-v2-${ENV}/groups/edit`, group);

  return response.data.content;
};

export const getParticipants = async (groupId?: string): Promise<any[]> => {
  const response = await api.get(`/whatsapp-v2-${ENV}/groups/participants`, {
    params: { id: groupId },
  });

  return response.data.content;
};
